import React from 'react';

/**
 * The validation message shown under a form field. Renders nothing when the
 * field is fine, so it can sit in the markup unconditionally.
 */
export default function FieldError({ msg }) {
  if (!msg) return null;
  return <div className="ds-error">{msg}</div>;
}
